module.exports = __webpack_public_path__ + "static/media/glow.52c4d73c.jpg";